import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";
import { Grandpa } from "../../actors/characters/grandpa";

import { goToScene } from "../../main";
import old from "../../actors/characters/oldLady";
import OldLady from "../../actors/characters/oldLady";

export default class Margies extends ex.Scene {
  constructor() {
    super();
    const player = new Player(18 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 5;
    let notice = new ex.Actor({
      pos: new ex.Vector(20 * 16, 7 * 16),
      height: 24,
      width: 100,
      color: ex.Color.fromHex("#80530f"),
    });
    this.margie = new OldLady({ x: 17 * 16, y: 14 * 16 });
    this.margie.z = 4;
  }
  onInitialize(engine) {
    Resources.MargiesMap.addToScene(this);
    console.log("mccartys: adding player: ", this.player);
    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);

    // this.player = Resources.HouseMap.getObjectsByName("player");

    this.camera.zoom = 1;
    // const map_bounds = ex.BoundingBox.fromDimension(
    //   Resources.TownMap.map.width * Resources.TownMap.map.tilewidth + 10,
    //   Resources.TownMap.map.height * Resources.TownMap.map.tileheight + 10,
    //   ex.Vector.Zero,
    //   Resources.TownMap.pos
    // );
    // this.camera.strategy.limitCameraBounds(map_bounds);

    this.door = new ex.Trigger({
      pos: new ex.Vector(16 * 16, 18 * 16 + 8),
      width: 48,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 9 * 16, y: 7 * 16, direction: "right" });
      },
    });
    this.add(this.door);
    this.player.on("collisionstart", (e) => {
      if (e.other.owner.name === "margie") {
        this.margie.startInteraction(this.player.lastDir, this.player);
      }
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    this.add(this.margie);
  }
  onDeactivate() {
    this.margie.kill();
  }
  onPostUpdate() {
    //     if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
    //       if (this.computerCollision) {
    //         console.log("pressed space, should go");
    //         goToScene("onlineMarket");
    //       }
    //     }
    //   }
  }
}
